module.exports = __webpack_public_path__ + "static/media/logo-white2.2ad7ae0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/statsradio/assets/img/logo-white2.png
// module id = ./src/statsradio/assets/img/logo-white2.png
// module chunks = 18